import styled from 'styled-components';

export const FormContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-row-gap: 0.5rem;
	grid-column-gap: 1rem;
	padding: 0;
	align-items: end;
`;
